import api from 'Application/api/api';

const passwordConfirmUploadedFilesVerificationForDistanceProcedure = (
    driverLicenseControlId,
    password,
    cancelToken = null,
) =>
    api.post(
        `/measures/vehicles/driver-licenses/controls/${driverLicenseControlId}/driver-license/distance-check/password-confirm-uploaded-files-verification`,
        {
            password,
        },
        {
            cancelToken,
        },
    );

export default passwordConfirmUploadedFilesVerificationForDistanceProcedure;
